import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { KNOWLEDGE_BASE_CREATE_EMAIL_LIST_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateListModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('CreateListModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.createList.heading"
    }),
    illustrationName: "segmented-lists",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.createList.description"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.createList.p1"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "setup-guide-components.modal.createList.li1"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "setup-guide-components.modal.createList.li2"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.createList.p2"
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: KNOWLEDGE_BASE_CREATE_EMAIL_LIST_URL,
      onClick: () => trackLink('create email list article'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    })]
  });
};
CreateListModal.propTypes = {
  onClose: PropTypes.func
};
export default CreateListModal;